<template>
    <a-card title="应用统计">
        <v-gobackbutton slot="extra">返回</v-gobackbutton>

        <serviceSearch :logkey="islogkey" ref="serviceSumSearchT" @searcchChange="handleSearchChange"></serviceSearch>

        <serviceChart ref="serviceChartID" style="margin-bottom:20px;"></serviceChart>


        <mtable :searchD="searchKey" :onlyFlow="onlyFlow" @handleUrlSelected="handleTableSelected" :style="{width:tableWidth}"></mtable>
    </a-card>
</template>

<script>
import serviceChart from './servicechart'
import mtable from "../appsum/table"
import serviceSearch from './search'

export default {
    data(){
        return {
            onlyFlow:3,
            tableWidth:'800px',
            searchKey:undefined,
            islogkey:false,
        }
    },
    methods:{
        handleTableSelected(url_){
            this.$refs.serviceSumSearchT.setDefaultUrl(url_)
        },
        getTableWidth(){
            this.tableWidth = (document.body.clientWidth - 282) + 'px'
        },
        handleSearchChange(searchKey){
            this.searchKey = searchKey;
            this.$refs.serviceChartID.getChartData(searchKey,searchKey.chartPerTime);
        }
    },
    mounted(){
        this.getTableWidth();
        window.addEventListener("resize", this.getTableWidth);
    },
    destroyed(){
        window.removeEventListener("resize", this.getTableWidth);

    },
    components:{
        serviceChart,
        mtable,
        serviceSearch
    }
};
</script>

<style lang="less" scoped>

</style>
